import {
  BILLING_DATE_CHANGED,
  CHANGE_BILLING_DATE,
  CLEAR_BILLING_DATE_CHANGE,
} from '../actions/billing/changeBillingDate';

const initialState = {
  processing: true,
  newBillDate: null,
  price: null,
  error: false,
};

export default (state = initialState, action = {}) => {
  if (action.error) {
    return { ...state, error: true, processing: false };
  }

  switch (action.type) {
    case CHANGE_BILLING_DATE:
      return {
        ...initialState,
      };
    case BILLING_DATE_CHANGED:
      return {
        ...initialState,
        processing: false,
        newBillDate: action.payload?.newBillDate,
        price: action.payload?.price,
      };
    case CLEAR_BILLING_DATE_CHANGE:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
